module.exports = __webpack_public_path__ + "static/media/musd.464d282c.svg";